import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await login(email, password); nav(next); }
    catch (err) { setError(apiError(err, "Accesso non riuscito.")); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Accedi" subtitle="Bentornato in Omniverse."
      footer={<>Non hai un account? <Link to="/registrati" className="text-[#2DD4BF] hover:underline">Registrati</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        {error && <div role="alert" data-testid="login-error" className="flex items-center gap-2 rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 px-3 py-2 text-sm text-[#FCA5A5]"><AlertCircle className="h-4 w-4" />{error}</div>}
        <div>
          <Label htmlFor="email" className="text-[#CBD5E1]">Email</Label>
          <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0B1020] border-[#2A3655]" />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-[#CBD5E1]">Password</Label>
            <Link to="/recupera-password" className="text-xs text-[#2DD4BF] hover:underline" data-testid="login-forgot">Password dimenticata?</Link>
          </div>
          <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0B1020] border-[#2A3655]" />
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#7C3AED] hover:bg-[#6D28D9]">{loading ? "Accesso…" : "Accedi"}</Button>
      </form>
    </AuthShell>
  );
}
